/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDim4CrossDiagIcon16Light } from './ArrowDim4CrossDiagIcon16Light';
import { ArrowDim4CrossDiagIcon16Regular } from './ArrowDim4CrossDiagIcon16Regular';
import { ArrowDim4CrossDiagIcon16Solid } from './ArrowDim4CrossDiagIcon16Solid';
import { ArrowDim4CrossDiagIcon20Light } from './ArrowDim4CrossDiagIcon20Light';
import { ArrowDim4CrossDiagIcon20Regular } from './ArrowDim4CrossDiagIcon20Regular';
import { ArrowDim4CrossDiagIcon20Solid } from './ArrowDim4CrossDiagIcon20Solid';
import { ArrowDim4CrossDiagIcon24Regular } from './ArrowDim4CrossDiagIcon24Regular';
import { ArrowDim4CrossDiagIcon24Solid } from './ArrowDim4CrossDiagIcon24Solid';
import { ArrowDim4CrossDiagIcon32Regular } from './ArrowDim4CrossDiagIcon32Regular';
import { ArrowDim4CrossDiagIcon64Regular } from './ArrowDim4CrossDiagIcon64Regular';
var sizes = {
    16: {
        light: ArrowDim4CrossDiagIcon16Light,
        regular: ArrowDim4CrossDiagIcon16Regular,
        solid: ArrowDim4CrossDiagIcon16Solid,
    },
    20: {
        light: ArrowDim4CrossDiagIcon20Light,
        regular: ArrowDim4CrossDiagIcon20Regular,
        solid: ArrowDim4CrossDiagIcon20Solid,
    },
    24: {
        regular: ArrowDim4CrossDiagIcon24Regular,
        solid: ArrowDim4CrossDiagIcon24Solid,
    },
    32: {
        regular: ArrowDim4CrossDiagIcon32Regular,
    },
    64: {
        regular: ArrowDim4CrossDiagIcon64Regular,
    },
};
export var ArrowDim4CrossDiagIcon = forwardRef('ArrowDim4CrossDiagIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
